import { getAuth0Instance } from '../auth0'

const multiGuard = guards => {
  const evaluateGuards = (_guards, to, from, next) => {
    const guardsLeft = [..._guards]
    const nextGuard = guardsLeft.shift()
    if (nextGuard === undefined) {
      return next()
    }

    nextGuard(to, from, nextArg => {
      if (nextArg === undefined) {
        return evaluateGuards(guardsLeft, to, from, next)
      }
      return next(nextArg)
    })
  }

  return (to, from, next) => evaluateGuards(guards, to, from, next)
}

const auth0Guard = (to, from, next) => {
  const authService = getAuth0Instance()
  const nextOrRedirectToAuth0 = () => {
    if (authService.isAuthenticated) {
      return next()
    }
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
  }

  // auth0 client is already initialized (you are already on the app)
  if (authService.isReady) {
    return nextOrRedirectToAuth0()
  }

  // install a watcher and wait until the auth0 client is initialized false --> true (you enter the app)
  authService.$watch('isReady', isReady => {
    if (isReady) {
      return nextOrRedirectToAuth0()
    }
  })
}

export {
  multiGuard,
  auth0Guard,
}
